export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-[#1C1612] text-[#A89C8F] py-14 px-6 border-t border-[#2E241D]"
  >
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
      <div className="flex items-center gap-3">
        <img
          src="/assets/logo.jpg"
          alt="De Houtregisseur logo"
          className="w-14 h-14 rounded-lg object-cover border border-[#3E322A]"
        />
        <div>
          <span className="block text-sm font-bold text-white font-display">DE HOUTREGISSEUR</span>
          <span className="block text-[10px] text-[#7A6C60]">Ambachtelijk maatwerk · Rijswijk</span>
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-6 text-xs">
        <a href="#collectie" data-testid="footer-link-werk" className="hover:text-white transition-colors">Werk</a>
        <a href="#rene" data-testid="footer-link-rene" className="hover:text-white transition-colors">Over René</a>
        <a href="#werkwijze" data-testid="footer-link-werkwijze" className="hover:text-white transition-colors">Werkwijze</a>
        <a href="#werkplaats" data-testid="footer-link-werkplaats" className="hover:text-white transition-colors">Werkplaats</a>
        <a href="#contact" data-testid="footer-link-aanvraag" className="hover:text-white transition-colors">Aanvraag</a>
        <a href="/admin" data-testid="footer-link-beheer" className="hover:text-white transition-colors">Beheer</a>
      </div>
      <div className="text-xs text-[#6B5E52] text-center md:text-right">
        <span className="block">De Houtregisseur · Maatwerk meubelen met karakter</span>
        <span className="block mt-1" data-testid="footer-kvk">KvK 42173027 · info@dehoutregisseur.nl</span>
      </div>
    </div>
  </footer>
);
